import {useState, useEffect} from "react";

const TableLicenses = ({itemList} ) => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        setData(itemList);
    }, []);

    useEffect(() => {
        // Apply filtering based on search term
        const filteredItems = data.filter(
            item =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.category.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(filteredItems);
        setCurrentPage(1); // Reset to the first page when the data changes
    }, [data, searchTerm]);


    const handlePrevPage = () => {
        setCurrentPage(prevPage => prevPage - 1);
    };

    const handleNextPage = () => {
        setCurrentPage(prevPage => prevPage + 1);
    };

    const handleSearch = e => {
        setSearchTerm(e.target.value);
    };

    // Get current items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const numberOfPages = Math.ceil(filteredData.length / itemsPerPage)

    return (
        <div className="container fade-element mx-auto p-4">
            <div className="mb-4 flex justify-end">
                <input
                    type="text"
                    placeholder="Search..."
                    className="px-4 py-2 border border-gray-300 rounded text-gray-900"
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </div>
            <div className="border-2 border-neutral-400 rounded-lg shadow-lg">
                <table className="min-w-full bg-neutral-950 rounded-lg">
                    <thead className="bg-gray-300 text-neutral-700 rounded-lg">
                    <tr>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left font-semibold tracking-wider">
                            Software
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left font-semibold tracking-wider">
                            Status
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left font-semibold tracking-wider">
                            About
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left font-semibold tracking-wider">
                            Expiration Date
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.map(item => (
                        <tr key={item.id}>
                            <td className="px-6 py-4 border-b border-gray-300"><b>{item.name}</b><br/>{item.category}</td>
                            <td className="px-6 py-4 border-b border-gray-300">
                                <span className=
                                          {item.status === "Activated" ? "inline-block bg-green-100 border border-green-500 rounded-full px-2 py-1 text-green-700" :
                                        item.status === "Purchased" ? "inline-block bg-white border border-neutral-900 rounded-full px-2 py-1 text-neutral-700" :
                                            "inline-block bg-neutral-700 border border-neutral-900 rounded-full px-2 py-1 text-neutral-400"}>
                                  {item.status}
                                </span>
                            </td>
                            <td className="px-6 py-4 border-b border-gray-300">
                                {item.description}
                            </td>
                            <td className="px-6 py-4 border-b border-gray-300">
                                {item.expiration_date}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>

                <div className="mt-4 flex justify-between items-center p-2 bg-natural-100">
                    <button
                        className="px-4 font-bold py-2 bg-orange-600 rounded disabled:bg-neutral-600 disabled:text-neutral-400 hover:bg-orange-200 hover:text-orange-600"
                        onClick={handlePrevPage}
                        disabled={currentPage === 1}
                    >
                        Prev
                    </button>
                    Page {filteredData.length === 0 ? "0" : currentPage} of {numberOfPages}
                    <button
                        className="px-4 font-bold py-2 bg-orange-600 rounded disabled:bg-neutral-600 disabled:text-neutral-400 hover:bg-orange-200 hover:text-orange-600"
                        onClick={handleNextPage}
                        disabled={currentItems.length < itemsPerPage || currentItems.length === 0}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TableLicenses;